module.exports = "/_next/static/images/img__notice_successRegister-d759719e49a6e6cc5137ae75dcd4e114.png";